export default "__VITE_ASSET__DKU$FPgi__"